<template>
	<EventCard
		v-bind="eventCardProps"
		:show-embed-payment-button="isPaymentProtected && !hasAccessToEvent(event)"
		:show-countdown="showCountdown"
		@init-embed-player="$emit('init-embed-player')"
	/>
</template>

<script>
import EventCard from '@shared/components/EventCard/EventCard';
import { EventCardProps } from '@shared/components/EventCard/EventCardProps';
import { mapGetters } from 'vuex';

export default {
	name:       'EventEmbedPreview',
	components: { EventCard },
	props:      {
		event: {
			type:    Object,
			default: () => {},
		},
		showInfos: {
			type:    Boolean,
			default: true,
		},
		showCountdown: {
			type:    Boolean,
			default: false,
		},
	},
	computed: {
		...mapGetters({
			hasAccessToEvent:   'sharedUser/hasAccessToEvent',
			isPaymentProtected: 'event/isPaymentProtected',
		}),
		eventCardProps() {
			return EventCardProps(this.event, { isEmbed: true, showInfos: this.showInfos, hidePaymentRestriction: this.hasAccessToEvent(this.event) });
		},
	},
};
</script>
